import { render, staticRenderFns } from "./CreateUpdateUserRole.vue?vue&type=template&id=f761c716&scoped=true&"
import script from "./CreateUpdateUserRole.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateUserRole.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateUserRole.vue?vue&type=style&index=0&id=f761c716&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f761c716",
  null
  
)

export default component.exports